export default __webpack_public_path__ + "static/media/carousel-3.be3e303a.webp";